import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large MerchantsActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить мерчанта?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.token,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.token) = $event)),
        "is-invalid": _ctx.state_form$.token.$error,
        "validation-errors": _ctx.state_form$.token.$errors,
        placeholder: "Токен"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        placeholder: "Маркетплейс",
        options: _ctx.MARKETPLACES,
        searchable: false,
        value: _ctx.state.marketplace_id,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.marketplace_id) = $event)),
        "is-invalid": _ctx.state_form$.marketplace_id.$error,
        "validation-errors": _ctx.state_form$.marketplace_id.$errors,
        class: "mt-4"
      }, null, 8, ["options", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "is-invalid": _ctx.state_form$.company_id.$error,
        "validation-errors": _ctx.state_form$.company_id.$errors,
        "infinite-scroll": "",
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany,
        class: "mt-4"
      }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_checkbox, {
        label: "Активный",
        value: _ctx.state.is_active,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.is_active) = $event)),
        class: "mt-2",
        "return-integer": ""
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}